import { useEffect, useState } from 'react';

import { fetchReasons } from '../api/reason';
import { fetchSchools } from '../api/school';
import { fetchSchoolLevelGroups } from '../api/school-level-group';
import { fetchSchoolYears } from '../api/school-year';
import { IReason } from '../types/reason.type';
import { ISchoolLevelGroup } from '../types/school-level-group.type';
import { ISchoolYear } from '../types/school-year.type';
import { ISchool } from '../types/school.type';

interface IDataPromise {
  key: 'school' | 'years' | 'groupCode' | 'reasons';
  promise: Promise<ISchool[]> | Promise<ISchoolYear[]> | Promise<ISchoolLevelGroup[]>;
}

export const useFetchPreInscriptionSummaryFiltersData = () => {
  const [isLoading, setLoading] = useState<boolean>(true);
  const [schools, setSchools] = useState<ISchool[]>([]);
  const [schoolYears, setSchoolYears] = useState<ISchoolYear[]>([]);
  const [schoolLevelGroups, setSchoolLevelGroups] = useState<ISchoolLevelGroup[]>([]);
  const [reasons, setReasons] = useState<IReason[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      const promises: IDataPromise[] = [
        { key: 'school', promise: fetchSchools() },
        { key: 'years', promise: fetchSchoolYears() },
        { key: 'groupCode', promise: fetchSchoolLevelGroups() },
        { key: 'reasons', promise: fetchReasons() },
      ];

      const items = await Promise.allSettled(promises.map(({ promise }) => promise));

      items.forEach((item, idx) => {
        const data = item.status === 'fulfilled' ? item.value : [];
        const { key } = promises[idx];

        switch (key) {
          case 'school':
            setSchools(data as ISchool[]);

            break;

          case 'years':
            setSchoolYears(data as ISchoolYear[]);

            break;

          case 'groupCode':
            setSchoolLevelGroups(data as ISchoolLevelGroup[]);

            break;

          case 'reasons':
            setReasons(data as IReason[]);

            break;

          default:
            break;
        }
      });
    };

    fetchData().finally(() => setLoading(false));
  }, []);

  return {
    schools,
    schoolYears,
    schoolLevelGroups,
    reasons,
    isLoading,
  };
};
